import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR,
} from "constants/ThemeConstant";
import { env } from "./EnvironmentConfig";
import moment from "moment";
import { CURRENT_USER } from "constants/AuthConstant";
export const APP_NAME = "Advancare";
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";
export const REDIRECT_URL_KEY = "redirect";
let redirectTo = `${APP_PREFIX_PATH}/dashboards/default`;
let currentUser = JSON.parse(localStorage.getItem(CURRENT_USER));
if (
  currentUser &&
  (currentUser["user_type"] == "cashier" ||
    currentUser["user_type"] == "agency")
) {
  redirectTo = `${APP_PREFIX_PATH}/neworder`;
} else if (currentUser && currentUser["user_type"] == "srd") {
  redirectTo = `${APP_PREFIX_PATH}/srd`;
} else if (currentUser && currentUser["user_type"] == "phlebotomy") {
  redirectTo = `${APP_PREFIX_PATH}/phlebotomy`;
} else if (currentUser && currentUser["user_type"] == "lab") {
  redirectTo = `${APP_PREFIX_PATH}/lab-receive`;
} else if (
  currentUser &&
  currentUser["user_type"] == "customer_feedback_officer"
) {
  redirectTo = `${APP_PREFIX_PATH}/complainingandsatisfaction`;
}
export const AUTHENTICATED_ENTRY = redirectTo;
export const UNAUTHENTICATED_ENTRY = "/login";
export const STAT_EXTRA_FEE = 100;
export const URGENT_EXTRA_FEE = 200;
export const UPDATE_ACTION = "UPDATE_ACTION";
export const NEW_ACTION = "NEW_ACTION";
export const USER_TYPES = [
  { value: "phlebotomy", name: "Phlebotomy" },
  { value: "cashier", name: "Cashier" },
  { value: "srd", name: "Srd" },
  { value: "lab", name: "Lab" },
  { value: "finance", name: "Finance" },
  { value: "doctor", name: "Doctor" },
  { value: "admin", name: "Admin" },
  { value: "agency", name: "Agency" },
  { value: "customer_feedback_officer", name: "customer_feedback_officer" },
];
export const REGIONS = [
  "Tigray",
  "Afar",
  "Amhara",
  "Oromia",
  "Somali",
  "Benishangul-Gumuz",
  "Southern Nations, Nationalities, and Peoples' Region (SNNPR)",
  "Gambela",
  "Harari",
  "Addis Ababa",
];
export const FEE_SCHEDULE_TYPES = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];
export const INITAIL_DATE_AND_TIME_FOR_ADVANCARE = {
  startDate: moment().subtract(1, "days").format("YYYYMMDD") + "000000",
  endDate: moment().format("YYYYMMDD") + "999999",
  agency: "null",
};

export const INITAIL_DATE_AND_TIME_1_Day_GAP = {
  startDate: moment().format("YYYYMMDD") + "000000",
  endDate: moment().add(1, "days").format("YYYYMMDD") + "000000",
  agency: null,
};

export const THEME_CONSTANT = "THEME_CONSTANT";

export const THEME_CONFIG = {
  isThemeChanging: false,
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: "en",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: localStorage.getItem(THEME_CONSTANT)
    ? localStorage.getItem(THEME_CONSTANT)
    : "light",
  direction: DIR_LTR,
  blankLayout: false,
};

export const DATE_AND_TIME_FOR_TABLE_FORMAT = "DATE_AND_TIME_FOR_TABLE_FORMAT";
export const MONTH_DAY_YEAR_WHILE_MONTH_IN_STRING_FORMAT =
  "MONTH_DAY_YEAR_WHILE_MONTH_IN_STRING_FORMAT";
export const AdvancareColorCodes = [
  "#5A3F6B",
  "#476E55",
  "#2C6791",
  "#996F33",
  "#708090",
  "#C46210",
  "#3B9C9C",
  "#9370DB",
  "#A0522D",
  "#DAA520",
  "#4682B4",
  "#7B68EE",
  "#6A5ACD",
  "#CD853F",
  "#BDB76B",
  "#008B8B",
  "#778899",
  "#8FBC8F",
  "#D2691E",
  "#B8860B",
  "#4169E1",
  "#483D8B",
  "#FF8C00",
  "#8B4513",
  "#BC8F8F",
  "#6B8E23",
  "#A9A9A9",
  "#F4A460",
  "#8A2BE2",
  "#20B2AA",
  "#A52A2A",
  "#B0C4DE",
  "#5F9EA0",
  "#DA70D6",
  "#DB7093",
  "#9ACD32",
  "#7FFFD4",
  "#708238",
  "#6495ED",
  "#D2B48C",
];

export const emojiEquvalentToText = {
  Sad: "😔",
  Normal: "😐",
  Happy: "😃",
  VeryHappy: "😊",
};
// Define your tube colors. You can use CSS color names, hex codes, or RGB values.
export const tubeColors = {
  SST: "gold", // Or yellow, for Serum Separator Tube
  LAV: "purple", // Lavender
  urin: "orange", // Urine is not a tube, but represents a sample type. Using orange as a general indicator.
  "AF&TB": "lightblue", // Assuming a specific tube for this
  "BL CUL": "green", // Blood Culture often has specific bottles, green is a common associated color
  BLOC: "gray", // Placeholder, adjust as needed
  BLU: "blue", // Light Blue for Coagulation
  BOTTLE: "darkgreen", // General bottle
  EDTA: "purple", // EDTA is the additive, but often in lavender tubes
  EPID: "brown", // Placeholder
  ESR: "black", // ESR often uses a specific black-top tube (Westergren)
  "FALCON TUBE": "white", // Falcon tubes are usually clear, could represent the cap color or just clear.
  FNA: "pink", // Fine Needle Aspiration, often a plain tube or specific preservative, using pink as a placeholder
  "Gray Tube": "gray", // Explicitly gray
  Heparium: "green", // Heparin tubes are green
  HIS: "teal", // Placeholder
  IDNOW: "cyan", // Placeholder
  JAR: "peru", // General container
  LBC: "olive", // Liquid Based Cytology, specific media, placeholder
  "O/P": "maroon", // Ova & Parasite, specific container, placeholder
  "Quantiferon tube": "darkred", // Quantiferon tubes have specific colored tops (red, gray, yellow, blue) - picking one for visual
  PAP: "lime", // Pap smear, specific liquid media
  "Pettry Dish": "darkblue", // Petri dish, transparent, placeholder
  PPT: "white", // Plasma Preparation Tube, often white or pearl top
  "Stool CUL": "saddlebrown", // Stool Culture
  SWAB: "darkgoldenrod", // Swab
  SYR: "lightgray", // Syringe, placeholder
  EPPENDORF: "darkcyan", // Eppendorf tubes are typically clear/frosted, using a color for distinction
};
